// Lightweight UTM / attribution capture.
// Reads UTM params, referrer and landing path on first page load,
// persists them in sessionStorage so they survive same-tab navigation,
// and exposes a getAttribution() helper for forms to attach to submissions.

const KEY = "tomc_attribution_v1";
const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

function readFromUrl() {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const out = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) out[k] = v.slice(0, 200);
  });
  return out;
}

export function captureAttribution() {
  if (typeof window === "undefined") return;
  try {
    const existing = sessionStorage.getItem(KEY);
    if (existing) return; // first-touch wins for the session

    const utms = readFromUrl();
    const data = {
      ...utms,
      referrer: (document.referrer || "").slice(0, 400) || null,
      landing_path:
        (window.location.pathname + window.location.search).slice(0, 400) ||
        null,
    };
    sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch (_e) {
    /* sessionStorage may be unavailable — silently ignore */
  }
}

export function getAttribution() {
  if (typeof window === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return {};
    const data = JSON.parse(raw);
    // Strip undefined/null so the backend doesn't store empty strings
    const cleaned = {};
    Object.entries(data).forEach(([k, v]) => {
      if (v) cleaned[k] = v;
    });
    return cleaned;
  } catch (_e) {
    return {};
  }
}
